<template>
  <div class="coming-soon">
    <Starboard />

    <div class="wrapper">
      <div class="centered">
        <img class="logo" alt="world-of-music.at" src="../assets/logo.svg">
        <div class="description">
          <h1>Hier entsteht etwas Neues!</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>
          <div class="email-field">
            <input type="text" placeholder="Email-Adresse" />
            <div class="btn">
              Notify me
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Starboard from '@/components/Starboard'

export default {
  name: 'ComingSoon',
  data: function() {
    return {
      stars: [],
    }
  },
  components: {
    Starboard,
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .coming-soon {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: transparent;
    z-index: 399;

    .wrapper {
      display: flex;
      position: absolute;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      z-index: 400;
      overflow-y: scroll;

      @media only screen and (min-width: 1260px) {
        .centered {
          flex-direction: row;

          p {
            max-width: 70%;
          }
        }

        img.logo {
          margin-left: 40px;
        }
      }

      @media only screen and (max-width: 1260px) {
        .centered {
          flex-direction: column;
          margin-top: 20px;
          min-height: 130vh;

          h1 {
            line-height: 40px;
          }

          p {
            width: 100%;

          }

          img.logo {
            height: 150px;
            margin-left: 0;
          }

          .description {
            .email-field {
              .btn {
                width: 100px;
              }
            }
          }
        }
      }

      .centered {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        max-width: 70%;

        img.logo {
          display: inline-flex;
          flex: 0 0 auto;
          width: 150px;
        }

        .description {
          display: inline-flex;
          flex-direction: column;
          align-items: center;

          flex: 0 1 auto;
          padding: 0;

          .email-field {
            display: inline-flex;
            flex-direction: row;
            margin-top: 24px;

            input {
              border-radius: 4px 0px 0px 4px;
              border: none;
              width: calc(100% - 100px);
              height: 34px;
              padding-left: 10px;
              font-family: 'Poppins';
              font-weight: 600;

              &::placeholder {
                color: #222;
              }
            }

            .btn {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              border-radius: 0 4px 4px 0;
              background: #2980FF;
              height: 34px;
              width: 100px;
              padding: 0 14px;
              font-size: 14px;
              font-weight: 600;
              color: #FFF;
            }
          }
        }

        h1 {
          display: inline-flex;
          color: #FFF;
          font-size: 36px;
          font-family: 'Poppins';
          font-weight: 700;
          //margin: 0;
          letter-spacing: -0.02rem;
          margin-bottom: 16px;
        }

        p {
          display: inline-flex;
          margin: 0;
        }
      }
    }

    .stars {
      position: fixed;
      width: 100vw;
      height: 100vh;
      left: 0;
      top: 0;
      pointer-events: none;

      .star {
        animation: moveRight 4s linear;

        img {

        }
      }
    }
  }

  @keyframes moveRight {
    0% {
      transform: translateX(0vw);
    }

    100% {
      transform: translateX(100vw);
    }
  }
</style>
